import { render } from "./CustomScrollbar.vue?vue&type=template&id=3da28ec2"
import script from "./CustomScrollbar.vue?vue&type=script&lang=js"
export * from "./CustomScrollbar.vue?vue&type=script&lang=js"

import "./CustomScrollbar.vue?vue&type=style&index=0&id=3da28ec2&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__